<template>
  <div>
    <!-- 上方主体 政府服务 政府EMM管理系统-->
    <div
      class="container_top"
      id="topCont"
      @mouseover="barNum = 0"
      v-if="contList">
      <!-- 轮播图 -->
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contList.picUrl"
          alt="" />
        <div class="cont_topTil">{{ contList.menuName }}</div>
        <!-- <div class="cont_topShad">Infrastructure services</div> -->
      </div>

      <div class="tapCont">
        <div class="tapAll">
          <div class="tapTxt">
            <div
              v-for="(item, index) in contList.menuModule"
              :key="index"
              class="tapOne"
              :class="tapFlg == index ? 'colr' : ''"
              @click="tapClic(index)">
              {{ item.title }}
            </div>
            <!-- <div
            class="tapOne"
            :class="tapFlg == 1 ? 'colr' : ''"
            @click="tapClic(1)"
          >
            {{ contList.menuModule[1].title }}
          </div> -->
          </div>
          <div class="memoryTap">
            <img
              @click="goHome('99')"
              style="margin: 0 10px; cursor: pointer"
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('3', contList.parentId)"
              >{{ contList.parentName }}</span
            >
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('2-2')"
              >{{ contList.menuName }}</span
            >
          </div>
        </div>
        <div
          :class="
            tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'
          ">
          <div class="tapTxt">
            <div
              v-for="(item, index) in contList.menuModule"
              :key="index"
              class="tapOne"
              :class="tapFlg == index ? 'colr' : ''"
              @click="tapClic(index)">
              {{ item.title }}
            </div>
            <!-- <div
            class="tapOne"
            :class="tapFlg == 2 ? 'colr' : ''"
            @click="tapClic(2)"
          >
            方案优势
          </div> -->
          </div>
          <div class="memoryTap">
            <img
              @click="goHome('99')"
              style="margin: 0 10px; cursor: pointer"
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('3', contList.parentId)"
              >{{ contList.parentName }}</span
            >
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
              alt="" />
            <span
              style="cursor: pointer"
              @click="goHome('2-2')"
              >{{ contList.menuName }}</span
            >
          </div>
        </div>
      </div>

      <!-- 方案介绍 -->
      <div
        class="publicCloud"
        id="advantage01"
        ref="textCont"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[0].title }}</div>
        <!-- <div class="publ_compe_fy">introduce</div> -->
        <div class="publ_compe_txt">
          {{ contList.menuModule[0].content }}
        </div>
        <div class="publCont">
          <div class="publ_img">
            <div class="img_Cont">
              <img
                :src="contList.menuModule[0].detailsList[0].imgUrl"
                alt="" />
              <!-- <div class="img_Cont_Tit">集团通讯</div> -->
            </div>
            <!-- <div class="publ_Tit">优势标题文案内容</div>
              <div class="publ_Txt">
                京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
              </div> -->
          </div>
        </div>
      </div>

      <!-- 方案优势 -->
      <div
        class="publicCloud"
        id="advantage02"
        v-if="contList.menuModule && contList.menuModule.length > 0">
        <div class="publ_compe_tit">{{ contList.menuModule[1].title }}</div>
        <!-- <div class="publ_compe_fy">advantage</div> -->
        <!-- <div class="publ_compe_txt">
            对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新
          </div> -->
        <div class="publCont">
          <div
            class="publ_img"
            v-for="(item, index) in contList.menuModule[1].detailsList"
            :key="index">
            <div class="img_Cont">
              <img
                :src="item.imgUrl"
                alt="" />
              <!-- <div class="img_Cont_Tit">集团通讯</div> -->
            </div>
            <div class="publ_Tit">{{ item.contentTitle }}</div>
            <div class="publ_Txt">
              {{ item.content }}
            </div>
          </div>
          <!-- <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://oss.jingshucloud.com/gw-bucket/e19338ca-4e5d-4105-9fcd-9c3eab19d576.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div>
        <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://oss.jingshucloud.com/gw-bucket/82d3e669-2042-426a-8495-3c245ffdc5fc.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div>
        <div class="publ_img">
          <div class="img_Cont">
            <img
              src="https://oss.jingshucloud.com/gw-bucket/831ebf2f-63c6-4b17-a699-5cd477ac293e.png"
              alt=""
            />
          </div>
          <div class="publ_Tit">优势标题文案内容</div>
          <div class="publ_Txt">
            京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
          </div>
        </div> -->
        </div>
      </div>
      <div class="publicCloud">
        <div
          class="privateCommUrl"
          v-if="contList.menuModule">
          下载链接：<a :href="contList.menuModule[1].externalUrl">{{
            contList.menuModule[1].externalUrl
          }}</a>
        </div>
      </div>

      <!-- 服务业务 -->
      <!-- <div class="publ_compe_txt">
            对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新对产品进行全方位拆解分析，AI洞察消费者需求和痛点，高效实现产品创新
          </div> -->
      <!-- <div class="publicCloud" id="advantage03">
          <div class="publ_compe_tit">服务业务</div>
          <div class="publ_compe_fy">business</div>
         
          <div class="publCont">
            <div class="publ_img">
              <div class="img_Cont">
                <img src="@/assets/enterprise/enterpriseService01.png" alt="" />
                <div class="img_Cont_Tit">集团通讯</div>
              </div>
              <div class="publ_Tit">优势标题文案内容</div>
              <div class="publ_Txt">
                京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
              </div>
            </div>
            <div class="publ_img">
              <div class="img_Cont">
                <img src="@/assets/enterprise/enterpriseService02.png" alt="" />
                <div class="img_Cont_Tit">集团通讯</div>
              </div>
              <div class="publ_Tit">优势标题文案内容</div>
              <div class="publ_Txt">
                京数科技（上海）有限公司是一家专注为用户提供“移动数据安全传输、存储解决方案”的互联网公司，通过软件与硬件的结合。
              </div>
            </div>
          </div>
        </div> -->

      <!-- <div class="botConsult">
          <div @click="goinquiyForm">项目需求咨询</div>
        </div> -->
    </div>
    <div id="mobile">
      <enterprisecublicCloud :navBar="navBar" :contList="contList" />
    </div>
  </div>
</template>

<script>
import { getCategoryInfo } from '@/api/index';
import enterprisecublicCloud from '@/views/mobile/enterpriseService/enterprisecublicCloud.vue';
export default {
  props: { switchNum: String },
  components: { enterprisecublicCloud },
  data() {
    return {
      tapHomeFlg: false,
      tapNum: 0,
      textLeftFlg: false,
      textRightFlg: false,
      tapFlg: '0',
      contList: {},
      flgId: '',
      navBar: [
        {
          icon: 'icon-home',
          path: '/goveHome',
          isRutern: false,
          name: '政务服务',
          params: {},
          query: {},
        },
        {
          icon: 'icon-right-1-copy',
          path: '',
          isRutern: false,
          name: '政府EMM管理系统',
          params: {},
          query: {},
        },
      ],
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum", curVal, oldVal);
      if (curVal == 2) {
        document
          .getElementById('topCont')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 2) {
      document.getElementById('topCont').scrollIntoView({ behavior: 'smooth' });
      this.textLeftFlg = true;
      this.textRightFlg = true;
    }

    // console.log(this.switchNum, this.textLeftFlg);
    console.log(
      this.$route.params,
      localStorage.getItem('menuId'),
      '二级页面数据展示'
    );
    if (this.$route.params.id) {
      localStorage.setItem('menuId', this.$route.params.id);
    }
    console.log(localStorage.getItem('menuId'));
    if (this.getID(this.$route.name, this.$store.state.treeList)) {
      localStorage.setItem(
        'menuId',
        this.getID(this.$route.name, this.$store.state.treeList).id
      );
    }
    this.flgId = localStorage.getItem('menuId');
    if (this.flgId) {
      getCategoryInfo(this.flgId).then((res) => {
        this.contList = res.data.data;
      });
    }
  },
  methods: {
    // 回调函数
    getID(name, list) {
      let _this = this;
      for (let item of list || []) {
        if (item.routingPath == name) return item;
        const sum = _this.getID(name, item.children);
        if (sum) return sum;
      }
    },
    goinquiyForm() {
      this.$router.push({
        name: 'InquiryForm',
        params: {},
      });
    },
    tapClic(row) {
      this.tapFlg = row;
      if (row == 0) {
        document
          .getElementById('advantage01')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 1) {
        document
          .getElementById('advantage02')
          .scrollIntoView({ behavior: 'smooth' });
      }
      if (row == 2) {
        document
          .getElementById('advantage03')
          .scrollIntoView({ behavior: 'smooth' });
      }
    },
    goHome(row, id) {
      this.$emit('switchflg', '0', row);
      if (row == '99') {
        this.$router.push({
          name: 'myHome',
          params: {},
        });
      }
      if (row == '3') {
        this.$router.push({
          name: 'goveHome',
          params: { id: id },
        });
        this.$store.commit('changeTabCheck', {
          idNum: row,
          sumName: '',
        });
        this.$store.state.enterp_somFlg = '';
      }
      if (row == '2-1') {
        this.$router.push({
          name: 'enterpriseHome/enterpriseService',
          params: {},
        });
        this.$store.commit('changeTabCheck', {
          idNum: row,
          sumName: '',
        });
        this.$store.state.enterp_somFlg = '';
      }
    },

    handleScroll() {
      if (this.$refs.textCont && this.$refs.textCont.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.textCont.offsetTop,
        //   this.switchNum
        // );
        // if (this.switchNum == 0) {
        //   this.textLeftFlg = false;
        //   this.textRightFlg = false;
        // }

        if (window.scrollY > 650) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        // if (window.scrollY > 80) {
        //   this.textLeftFlg = true;
        //   this.textRightFlg = true;
        // }

        this.$emit('switchflg', '0');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    // left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    opacity: 0.8;
    position: absolute;
    bottom: 46%;
    left: 13%;
    font-size: 18px;
    color: white;
  }
}

// 文字菜单栏动画
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: '';
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  //tap动画
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .tapHome {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
  .tapTxt {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-left: -20px;
  }
  .memoryTap {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .memoryTap img {
    width: 20px;
  }
}

// 方案介绍
.publicCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 100px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  // .publ_compe_tit::before {
  //   content: "";
  //   height: 1px;
  //   background: #151a23;
  //   position: absolute;
  //   top: 60px;
  //   width: 100%;
  // }
  .publ_compe_fy {
    font-size: 20px;
    color: #8a8c91;
    // 文字渐变
    // background: linear-gradient(to top, #ffffff 0%, #ffffff 25%, #f4ca80 100%);
    // background-clip: text;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .publ_compe_txt {
    // width: 80%;
    margin-top: 60px;
    // text-align: center;
    width: 1000px;
  }

  .publCont {
    display: flex;
    justify-content: center;
    // align-items: center;
    // margin: 80px;
    // flex-wrap: wrap;
    // width: 87%;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;
    // width: 22%;
  }
  .publ_img img {
    display: block;
    width: 100%;
  }
  //  .publ_img div {
  //    margin-top: 20px;
  //  }
  .img_Cont {
    position: relative;
  }
  .img_Cont_Tit {
    position: absolute;
    bottom: 40px;
    color: #fff;
    font-size: 20px;
    margin-left: 40px;
  }
  .publ_Tit {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top: 20px;
  }
  .publ_Txt {
    text-align: justify;
  }
}
.privateCommUrl {
  width: 100%;
  max-width: 1200px;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 20px;
}

.botConsult {
  height: 100%;
  background: #fff;
  padding: 80px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.botConsult div {
  color: #fff;
  cursor: pointer;
  background: #04758e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-radius: 6px;
}
</style>
<style lang="scss" scoped>
@import '@/assets/variables.scss';
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
